import { chain, push } from 'icepick';
import type { Action } from '../../../actions';
import { SET_APP_DATA } from '../../../actions/app';
import { SET_VERSIONS, UPDATE_VERSION } from '../../../actions/version';
import type { VersionState } from './types';

const defaultState: VersionState = { versions: [] };

const versionReducer = (state: VersionState = defaultState, action: Action): VersionState => {
	switch (action.type) {
		case SET_APP_DATA:
			return action.payload.entities.version;
		case SET_VERSIONS:
			return action.payload;
		case UPDATE_VERSION: {
			if (state.versions.includes(String(action.payload.version.id))) {
				return state;
			}
			return chain(state)
				.setIn(['versions'], push(state.versions, String(action.payload.version.id)))
				.value();
		}
		default: {
			// @ts-expect-error - TS2322: Type 'BatchAction | ShowErrorFlagAction | InitializeAppPropsAction | LoadAppDataAction | LoadAppDataFailureAction | ... 173 more ... | SetIncludeSubtasksAction' is not assignable to type 'never'.
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default versionReducer;
